import styled, { css } from 'styled-components'
import { IPFullWidth } from './interface'

export const LegendWrapper = styled.div`
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.xs} ${theme.space.sm} ${theme.space.xs}`};
  width: max-content;
  background-color: ${({ theme }) => theme.colors.ui06};

  &.base {
    margin-left: ${({ theme }) => theme.space.md};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: ${({ theme }) => `${theme.space.sm} ${theme.space.lg} ${theme.space.sm} ${theme.space.xs}`};

    &.base {
      margin-left: ${({ theme }) => theme.space.lg};
    }
  }
`

export const Legends = styled.div<IPFullWidth>`
  display: flex;
  align-items: center;

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      background-color: ${({ theme }) => theme.colors.ui06};
      justify-content: space-between;

      ${LegendWrapper} {
        width: max-content;

        &.base {
          margin-left: 0;
        }
      }
    `}
`
